import { Menu } from 'antd';
import { breakpoints } from '../../../styles/breakpoints';
import styled from 'styled-components';

import { LogoutOutlined } from '@ant-design/icons';

export const StyledMenu = styled(Menu)`
  border-bottom: none;

  .horizontal-menu-tutorials {
    a {
      font-size: 12px;
      display: flex;
      flex-direction: row;
      align-items: center;
      text-transform: uppercase;
      font-weight: 600;

      @media ${breakpoints.screen350} {
        font-size: 14px;
      }
    }

    .anticon {
      margin: 0 0 0 10px !important;
      font-size: 20px !important;

      @media ${breakpoints.screen350} {
        font-size: 25px !important;
      }
    }
  }

  .horizontal-menu-user {
    border-bottom: none !important;

    .ant-menu-submenu-title {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
    }

    .ant-menu-title-content {
      font-size: 12px;
      color: black !important;
      margin-right: 10px;

      @media ${breakpoints.screen350} {
        font-size: 14px;
      }
    }

    svg {
      width: 20px;
      height: 20px;

      @media ${breakpoints.screen350} {
        width: 25px;
        height: 25px;
      }
    }
  }
`;

export const StyledLogoutIcon = styled(LogoutOutlined)`
  svg {
    width: 12px;
    height: 12px;
    margin-left: 10px;
  }
`;
